export default class TipoICMS {
  constructor(id, codigo, descricao) {
    this.id = id
    this.codigo = codigo
    this.descricao = descricao
  }
}
